import React from 'react';
import './Testimonials.css';

function Testimonials() {
  const reviews = [
    {
      id: 1,
      name: "Rajesh Kumar",
      location: "Bangalore",
      text: "Very helpful service. I wanted to publish a name change ad in Deccan Herald. The team guided me with the affidavit format and the ad was published the next day.",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      location: "Delhi",
      text: "Best rates for Matrimonial ads. I compared with local agents and BookMyNewsAd was 20% cheaper. Highly recommended!",
      rating: 5
    },
    {
      id: 3,
      name: "Suresh Menon",
      location: "Chennai",
      text: "Excellent support via WhatsApp. They helped me draft the obituary ad for my father and ensured it was published in The Hindu on time.",
      rating: 5
    },
    {
      id: 4,
      name: "Ramesh Gowda",
      location: "Mysore",
      text: "ವಿಜಯವಾಣಿಯಲ್ಲಿ ಜಾಹೀರಾತು ನೀಡಲು ತುಂಬಾ ಸುಲಭವಾದ ಮಾರ್ಗ. ಬೆಲೆ ಕೂಡ ಕಡಿಮೆ.",
      rating: 5
    },
    {
      id: 5,
      name: "Anjali Nair",
      location: "Kochi",
      text: "മനോരമയിൽ പരസ്യം നൽകാൻ ഇവർ വളരെ സഹായിച്ചു. വാട്സാപ്പിലൂടെ എല്ലാം എളുപ്പത്തിൽ ചെയ്തു.",
      rating: 5
    },
    {
      id: 6,
      name: "Karthik Raja",
      location: "Madurai",
      text: "தினத்தந்தியில் விளம்பரம் செய்ய சிறந்த இடம். நல்ல சேவை.",
      rating: 5
    },
    {
      id: 7,
      name: "Amit Verma",
      location: "Patna",
      text: "दैनिक जागरण में विज्ञापन देने के लिए सबसे अच्छी वेबसाइट। बहुत ही आसान प्रक्रिया।",
      rating: 5
    },
    {
      id: 8,
      name: "Venkat Rao",
      location: "Hyderabad",
      text: "ఈనాడు పేపర్‌లో యాడ్ ఇవ్వడానికి చాలా మంచి సర్వీస్. ధరలు కూడా తక్కువ.",
      rating: 4.5
    },
    {
      id: 9,
      name: "Lakshmi Narayan",
      location: "Vijayawada",
      text: "సాక్షి పేపర్‌లో మ్యాట్రిమోనియల్ యాడ్ ఇచ్చాను. రెస్పాన్స్ బాగుంది.",
      rating: 5
    },
    {
      id: 10,
      name: "Shivakumar",
      location: "Hubli",
      text: "ಪ್ರಜಾವಾಣಿ ಜಾಹೀರಾತು ಬುಕಿಂಗ್ ತುಂಬಾ ಸುಲಭವಾಗಿತ್ತು. ಉತ್ತಮ ಸೇವೆ.",
      rating: 4.5
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="container">
        <h2 className="section-title">Trusted by 1 Lakh+ Customers</h2>
        <p className="section-subtitle">See what our clients have to say about us</p>
        
        <div className="testimonials-marquee">
          <div className="marquee-content">
            {[...reviews, ...reviews].map((review, index) => (
              <div key={`${review.id}-${index}`} className="testimonial-card">
                <div className="stars">
                  {"★".repeat(Math.floor(review.rating))}
                  {review.rating % 1 !== 0 && "½"}
                </div>
                <p className="review-text">"{review.text}"</p>
                <div className="reviewer-info">
                  <div className="reviewer-avatar">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="reviewer-name">{review.name}</h4>
                    <span className="reviewer-location">{review.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
